
import { Base } from '../base-component';

import './form-item-business-lending-cmb.component.scss';

export class FormItemBusinessLendingCmb extends Base {

	form: HTMLFormElement;
	enquiryType: Element;
	recipientInput: any;
	emailInput: any;
	subjectInput: any;
	submitBtn: Element[];

	constructor(element: Element) {
		super(element);
	}
	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.enquiryType = this.element.querySelector('select[name=enquiry-type]');

		this.recipientInput = this.element.querySelector('input[name=recipient]');
		this.emailInput = this.element.querySelector('input[name=email]');
		this.subjectInput = this.element.querySelector('input[name=subject]');

	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));



		if (this.enquiryType) {
			this.enquiryType.addEventListener('change', (event: any) => this.queryType(event));
		}

	}

	queryType(event: any) {
		let value: any = event.target.value;

		this.recipientInput.value = value;
		this.emailInput.value = value;

		const _form: HTMLFormElement = this.enquiryType.closest('form');
		const _phoneNumber: HTMLInputElement = _form.querySelector('input[name=phone-number]');
		const _phoneParent = _phoneNumber.parentElement;
		if (value === 'enterprisedirect2@standardbank.co.za') {
			const _businessReg: HTMLInputElement = _form.querySelector('input[name=business-registration]');
			if (!_businessReg) {
				const _newElement = document.createElement('div');
				_newElement.classList.add('form__group');

				const _newLabel = document.createElement('label');
				_newLabel.classList.add('form__label');
				_newLabel.appendChild(document.createTextNode('Business Registration'))

				const _newInput = document.createElement('input');
				_newInput.classList.add('form__input', 'form__input--required');
				_newInput.setAttribute('name', 'business-registration');
				_newInput.setAttribute('value', '');
				_newInput.setAttribute('type', 'text');
				_newInput.setAttribute('placeholder', 'Enter your business registration number');

				_newElement.appendChild(_newLabel);
				_newElement.appendChild(_newInput);

				_phoneParent.parentNode.insertBefore(_newElement, _phoneParent.previousSibling);
			}
		} else {
			const _businessReg: HTMLInputElement = _form.querySelector('input[name=business-registration]');
			if (_businessReg) {
				const _temp = _businessReg.parentNode;
				_temp.parentNode.removeChild(_temp);
			}
		}

	}

	resetForm() {

		if (this.form) {

			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			formContainerLoader.classList.remove('active');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}

	}

}



// WEBPACK FOOTER //
// ./components/form-item-business-lending-cmb/form-item-business-lending-cmb.component.ts